export default "__VITE_ASSET__D5FEfr1w__"